import { render } from "./OrdersShowCardBilling.vue?vue&type=template&id=c65de118"
import script from "./OrdersShowCardBilling.vue?vue&type=script&lang=js"
export * from "./OrdersShowCardBilling.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__